import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export class SubmissionFile extends HasProjectMixin(Model) {
  declare id: number;
  declare board: number;
  declare submission: number;
  declare url: string;
  declare thumbnailUrl: string;
  declare name: string;
  declare sizeBytes: number | null;
  declare createdAt: Date;
  declare updatedAt: Date;

  static get $name() {
    return "SubmissionFile";
  }

  static get fields() {
    return [
      "id",
      "board",
      "submission",
      "url",
      { name: "thumbnailUrl", dataSource: "thumbnail_url" },
      "name",
      { name: "sizeBytes", dataSource: "size_bytes", type: "number" },
      { name: "createdAt", dataSource: "created_at", type: "date" },
      { name: "updatedAt", dataSource: "updated_at", type: "date" },
    ];
  }
}

// @ts-expect-error - exposeProperties is internal method
SubmissionFile.exposeProperties();
